var React = require('react');

function ArrowDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M94.5,311.29l0,-309.214l18,0l0,309.214l82.542,-55.027l9.984,14.976l-101.526,67.685l-101.526,-67.685l9.984,-14.976l82.542,55.027Z"}));
}

ArrowDown.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 208 341","version":"1.1","xmlSpace":"preserve","style":{"fillRule":"evenodd","clipRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2"}};

module.exports = ArrowDown;

ArrowDown.default = ArrowDown;
